import { RuleCreatePageKey, RuleListPageKey } from '../../TModules';

export const translations = {
  [RuleListPageKey]: {
    SearchPlaceholder: 'Regel nach Name oder ID oder internen Notizen suchen',
    ApproveRequests: 'Anfragen genehmigen',
    CreateRule: 'Regel erstellen',
    Rules: 'Regeln',
    RuleActivatedSuccessfully: 'Regel erfolgreich aktiviert.',
    ActivationRequestSubmittedForApproval: 'Aktivierungsanfrage zur Genehmigung eingereicht.',
    RuleDeactivatedSuccessfully: 'Regel erfolgreich deaktiviert.',
    RuleDeactivationRequestSubmittedForApproval:
      'Deaktivierungsanfrage zur Genehmigung eingereicht.',
    MultipleApproveRequestSuccessMessage:
      'Mehrfache Genehmigungsanfrage zur Bestätigung eingereicht.',
    ErrorApprovingRewards: 'Fehler beim Genehmigen der Belohnungen.',
    ApproveMultipleRequests: 'Mehrere Anfragen genehmigen?',
    ApproveSelected: 'Ausgewählte genehmigen',
    ApproveMultipleRequestsMessageLineOne:
      'Möchten Sie wirklich alle ausgewählten Anfragen genehmigen?',
    ApproveMultipleRequestsMessageLineTwo:
      'Bitte überprüfen Sie die Details vor der Genehmigung, da diese Aktion nicht rückgängig gemacht werden kann.',
    ApproveRequestSuccessMessage: 'Genehmigungsanfrage erfolgreich.',
    SomethingWentWrong: 'Etwas ist schief gelaufen.',
    ApproveRuleTitle: 'Regel genehmigen?',
    SubmitDeletionRequestTitle: 'Löschungsanfrage einreichen?',
    Approve: 'Genehmigen',
    RequestDeletion: 'Löschung beantragen',
    ApproveRuleMessageLineOne: 'Sind Sie sicher, dass Sie diese Regel genehmigen möchten?',
    ApproveRuleMessageLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    SubmitDeletionRequestMessageLineOne:
      'Diese Regel wartet auf Genehmigung. Sind Sie sicher, dass Sie sie löschen möchten?',
    SubmitDeletionRequestMessageLineTwo:
      'Sobald die Löschung genehmigt ist, wird diese Regel nicht mehr verfügbar sein und Sie müssen sie neu erstellen.',
    Tabs: {
      All: 'Alle',
      Scheduled: 'Geplant',
      Active: 'Aktiv',
      Inactive: 'Inaktiv',
      Ended: 'Beendet',
      Pending: 'Ausstehend'
    },
    Columns: {
      RuleName: 'Regelname',
      Status: 'Status',
      Comment: 'Kommentar',
      RequestType: 'Anfragetyp',
      Balance: 'Kontostand',
      StartDate: 'Startdatum',
      EndDate: 'Enddatum',
      Trigger: 'Auslöser',
      Outcome: 'Ergebnis',
      Actions: 'Aktionen',
      ID: 'ID',
      Rule: 'Regel',
      Loyalty: 'Treue',
      Reward: 'Belohnung',
      Milestone: 'Meilenstein',
      Customer: 'Kunde',
      Transaction: 'Transaktion',
      Location: 'Standort',
      CumulativeSpend: 'Kumulierter Umsatz',
      Others: 'Andere',
      Multiple: 'Mehrere'
    },
    Errors: {
      ErrorActivatingRule: 'Fehler beim Aktivieren der Regel',
      ErrorDeactivatingRule: 'Fehler beim Deaktivieren der Regel'
    },
    Actions: {
      Show: 'Anzeigen',
      Approve: 'Genehmigen',
      Review: 'Überprüfen',
      Activate: 'Aktivieren',
      Deactivate: 'Deaktivieren',
      Duplicate: 'Duplizieren',
      Edit: 'Bearbeiten'
    },
    CampaignRuleModal: {
      Create: 'Kampagnenregel erstellen',
      Edit: 'Kampagnenregel bearbeiten',
      OkText: 'Hinzufügen',
      UpdateText: 'Aktualisieren',
      RuleName: 'Regelname',
      RuleType: 'Regeltyp',
      RuleGetsTriggeredIf: 'Regel wird ausgelöst wenn:',
      Priority: 'Priorität',
      RuleOutcome: 'Regelergebnis',
      OutcomeType: 'Ergebnistyp',
      OutcomeValue: 'Ergebniswert',
      OutcomeValuePlaceholder: 'Ergebniswert eingeben'
    },
    RuleTriggerLimitSegment: {
      TriggerLimits: 'Auslöserlimits',
      TotalNumberOfTriggerEvents: 'Gesamtzahl der Auslöserereignisse (auf Kampagnenebene)',
      TriggerLimit: 'Auslöserlimit',
      TriggerLimitPlaceholder: '∞',
      TotalNumberOfTriggerEventsPerUser: 'Gesamtzahl der Auslöserereignisse (pro Benutzer)',
      TriggerRateLimitPerUser: 'Auslöserratenlimit (pro Benutzer)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        'Lassen Sie die Limitfelder leer für unbegrenzte Auslöserereignisse',
      Days: 'Tage',
      Weeks: 'Wochen',
      Months: 'Monate',
      Years: 'Jahre',
      TriggerEventsForEvery: 'Auslöserereignis(se) für jeden'
    },
    TransactionalFields: {
      ChooseOne: 'Wählen Sie eine...',
      SelectTrigger: 'Auslöser wählen',
      AddCondition: 'Bedingung hinzufügen',
      FromDate: 'Von Datum',
      ToDate: 'Bis Datum',
      And: 'Und'
    },
    TransactionPropertyField: {
      PropertyDataType: 'Eigenschaftsdatentyp',
      Key: 'Schlüssel',
      Sunday: 'Sonntag',
      Monday: 'Montag',
      Tuesday: 'Dienstag',
      Wednesday: 'Mittwoch',
      Thursday: 'Donnerstag',
      Friday: 'Freitag',
      Saturday: 'Samstag',
      Value: 'Wert',
      PleaseSeparateMultipleValuesUsingComma: 'Bitte trennen Sie mehrere Werte durch Kommas',
      SelectOperator: 'Operator auswählen',
      Loading: 'Laden...',
      TableName: 'Tabellenname',
      Type: 'Typ',
      SampleValues: 'Beispielwerte',
      Operator: 'Operator'
    },
    AutomationFields: {
      SelectTrigger: 'Auslöser wählen',
      ChooseOne: 'Wählen Sie eine...',
      OutcomeType: 'Ergebnistyp',
      SelectTriggerPlaceholder: 'Bitte wählen Sie einen Auslöser'
    },
    MerchantRewardSelectField: {
      SelectMerchant: 'Händler auswählen',
      Edit: 'Bearbeiten',
      Add: 'Hinzufügen',
      Merchant: 'Händler'
    },
    MerchantSelectModal: {
      Title: 'Händler auswählen',
      AddMerchant: 'HÄNDLER HINZUFÜGEN',
      Cancel: 'ABBRECHEN',
      SearchPlaceholder: 'Händler nach Name oder ID suchen',
      Active: 'Aktiv',
      Inactive: 'Inaktiv',
      Name: 'Name',
      Status: 'Status',
      DateCreated: 'Erstellungsdatum',
      ID: 'ID'
    },
    RewardSelectField: {
      SelectReward: 'Belohnung auswählen',
      Edit: 'Bearbeiten',
      Add: 'Hinzufügen',
      Reward: 'Belohnung'
    },
    RewardSelectModal: {
      Title: 'Belohnung auswählen',
      AddReward: 'Belohnung hinzufügen',
      Cancel: 'Abbrechen',
      SearchPlaceholder: 'Belohnung nach Name, ID oder Händler suchen',
      All: 'Alle',
      Active: 'Aktiv',
      Approved: 'Genehmigt',
      Private: 'Privat',
      System: 'System',
      Merchant: 'Händler',
      Balance: 'Kontostand',
      SellingFrom: 'Verkauf von',
      SellingTo: 'Verkauf bis',
      Reward: 'Belohnung',
      RewardName: 'Belohnungsname',
      ID: 'ID'
    }
  },
  [RuleCreatePageKey]: {
    LoadingRule: 'Regel wird geladen',
    Steps: {
      SetupRule: 'Regel einrichten',
      SetupAudience: 'Zielgruppe einrichten',
      Review: 'Überprüfen'
    },
    EditMessage: {
      MakerCheckerSuccess: 'Anfrage zur Genehmigung eingereicht',
      Success: 'Automatisierungsregel erfolgreich bearbeitet!',
      TransactionRulesError: 'Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.',
      RuleRequestError: 'Fehler beim Einrichten der Automatisierung',
      TransactionRulesSuccess: 'Automatisierungsregel erstellt!',
      TransactionRulesMakerCheckerSuccess: 'Regel zur Genehmigung eingereicht',
      TransactionRulesRequestError: 'Fehler beim Einrichten der Automatisierung'
    },
    Cancel: 'Abbrechen',
    Back: 'Zurück',
    SaveAsDraft: 'Als Entwurf speichern',
    Publish: 'Veröffentlichen',
    Launch: 'Starten',
    Next: 'Weiter',

    RuleSetup: {
      Essentials: 'Grundlegendes',
      Name: 'Name',
      NamePlaceholder: 'Geben Sie hier Ihren Regelnamen ein',
      Labels: 'Labels',
      LabelsPlaceholder: 'Geben Sie hier Ihre Labels ein',
      Partner: 'Partner',
      PartnerPlaceholder: 'Bitte wählen Sie Ihren Partner aus',
      Owner: 'Besitzer',
      OwnerPlaceholder: 'Bitte wählen Sie einen Besitzer aus',
      Mechanics: 'Mechanik',
      ValidityPeriod: 'Gültigkeitszeitraum',
      TriggerLimits: 'Auslösungslimits',
      TotalNumberofTriggerEvents: 'Gesamtzahl der Auslöseereignisse (auf Kampagnenebene)',
      TotalNumberofTriggerEventsPerUser: 'Gesamtzahl der Auslöseereignisse (pro Benutzer)',
      TriggerRateLimitPerUser: 'Auslösungsratenlimit (pro Benutzer)',
      TriggerRateLimitOnCampaignLevel: 'Auslösungsratenlimit (auf Kampagnenebene)',
      Days: 'Tage',
      Weeks: 'Wochen',
      Months: 'Monate',
      Years: 'Jahre',
      LimitTo: 'Begrenzen auf',
      TriggerEvent: 'Auslöseereignis(se) für jeden',
      UnlimitedTriggerEvents: 'Lassen Sie das Limit-Feld leer für unbegrenzte Auslöseereignisse',
      Startdate: 'Startdatum',
      Enddate: 'Enddatum',
      NoEnddate: 'Kein Enddatum',
      SelectATrigger: 'Auslöser auswählen:',

      SelectLoyaltyProgram: 'Treueprogramm auswählen',
      SelectNextTier: 'Nächste Stufe auswählen',
      SelectCampaign: 'Kampagne auswählen',
      Custom: 'Benutzerdefiniert',
      Transaction: 'Transaktion',
      Loyalty: 'Treue',
      Reward: 'Belohnung',
      Milestone: 'Kampagne',
      Customer: 'Kunde',
      Location: 'Standort',
      SelectTrigger: 'Auslöser auswählen',
      AgeingPointsHelp:
        'Die Anzahl der ablaufenden Punkte wird zu Beginn jedes Überprüfungszyklus geprüft.',
      AchievedNextTier: 'Nächste Stufe erreicht',
      NearTier: '10% bis zur nächsten Stufe',
      PointsIssued: 'Punkte vergeben',
      AgeingPoints: 'Alternde Punkte (Punkte, die im aktuellen Zyklus ablaufen)',
      RedeemReward: 'Belohnung einlösen',
      IssueReward: 'Belohnung ausgeben',
      IssueRewardFromCampaign: 'Belohnung aus Kampagne ausgeben',
      IssueRewardFromMerchant: 'Belohnung vom Händler ausgeben',
      VoucherForParticularRewardExpiringIn: 'Gutschein für bestimmte Belohnung läuft ab in',
      AnyVoucherExpiringIn: 'Beliebiger Gutschein läuft in {days} Tagen ab',
      StampRedeemed: 'Stempel eingelöst',
      StampsIssued: 'Stempel ausgegeben',
      StampsInactive: 'Stempel inaktiv',
      GamePlayed: 'Spiel gespielt',
      GameTryIssued: 'Spielversuch ausgegeben',
      CampaignEnrolled: 'An Kampagne teilgenommen',
      CampaignCompleted: 'Kampagne abgeschlossen',
      CampaignNotCompleted: 'Kampagne nicht abgeschlossen',
      ProgressLevelAchieved: 'Fortschrittsstufe erreicht',
      ProgressRuleTriggered: 'Fortschrittsregel ausgelöst',
      QuestTaskCompleted: 'Quest-Aufgabe abgeschlossen',
      CampaignOutcomeIssued: 'Kampagnenergebnis ausgegeben',
      SignUp: 'Registrierung',
      SignIn: 'Anmelden',
      ProfileUpdated: 'Profil aktualisiert',
      LoyaltyProgramSelectPlaceholder: 'Treueprogramm auswählen',
      SelectTriggerPlaceholder: 'Bitte wählen Sie einen Auslöser aus',
      RuleTriggerDays: 'Regelauslösetage',
      TriggerDays: 'Auslösetage',
      TriggerOnSpecificDays: 'An bestimmten Tagen auslösen',
      HoverMe: 'Zeig auf mich',
      From: 'Von',
      To: 'Bis',
      SelectDays: 'Tage auswählen',
      SelectTime: 'Zeit auswählen'
    },

    MilestoneField: {
      SelectStampCampaign: 'Stempelkampagne auswählen',
      Change: 'Ändern',
      Select: 'Auswählen',
      StampCampaign: 'Stempelkampagne',
      AnyRewardsSelected:
        'Alle {isCampaignRewardsSelected} Belohnungen in dieser Kampagne werden ein Auslöser sein',
      SelectStampsSlot: 'Stempelplatz auswählen',
      SelectStampsSlotHelper:
        'If this field is left blank, the rule will apply to stamp issuance at any stamp position and will trigger accordingly.',
      SelectStampPosition: 'Stempelkartenposition auswählen',
      AutoFillExcludedHelper:
        'Only Stamp Campaigns with Auto-fill Stamp set to OFF can be selected.'
    },

    CampaignSelectField: {
      Interval: 'Intervall',
      Days: '(Tage)',
      SelectStampCampaign: 'Stempelkampagne auswählen',
      Change: 'Ändern',
      Select: 'Auswählen',
      StampCampaign: 'Stempelkampagne',
      SelectACampaign: 'Kampagne auswählen',
      Edit: 'Bearbeiten',
      Add: 'Hinzufügen',
      Campaign: 'Kampagne',
      ID: 'ID',
      SelectAMilestone: 'Meilenstein auswählen',
      SelectARule: 'Regel auswählen',
      SelectATask: 'Aufgabe auswählen',
      SelectCampaignOutcome: 'Kampagnenergebnis auswählen',
      SelectOutcomePlaceholder: 'Bitte wählen Sie ein Kampagnenergebnis aus',
      AnyOutcome: 'Beliebiges Ergebnis'
    },

    GameSelectField: {
      SelectAGameCampaign: 'Spielkampagne auswählen',
      Game: 'Spiel',
      Campaign: 'Kampagne',
      Change: 'Ändern',
      Select: 'Auswählen'
    },

    CampaignRewardSelectField: {
      SelectACampaign: 'Kampagne auswählen',
      Change: 'Ändern',
      Select: 'Auswählen',
      Campaign: 'Kampagne',
      SelectAReward: 'Belohnung auswählen (Optional)',
      Reward: 'Belohnung',
      ID: 'ID'
    },

    MerchantRewardSelectField: {
      SelectAMerchant: 'Händler auswählen',
      Change: 'Ändern',
      Select: 'Auswählen',
      Merchant: 'Händler',
      AddMerchant: 'Händler hinzufügen',
      Cancel: 'Abbrechen',
      SearchMerchant: 'Händler nach Name oder ID suchen',
      Active: 'Aktiv',
      Inactive: 'Inaktiv',
      ID: 'ID'
    },

    RewardSelectField: {
      SelectAReward: 'Belohnung auswählen (Optional)',
      Change: 'Ändern',
      Reward: 'Belohnung',
      Select: 'Auswählen',
      WarningText:
        'Ergebnistyp ist auf [Push Event] beschränkt, wenn eine Systembelohnung ausgewählt ist'
    },

    RewardExpirySetupField: {
      SelectAReward: 'Belohnung auswählen',
      Change: 'Ändern',
      Select: 'Auswählen',
      Reward: 'Belohnung',
      Periods: 'Zeiträume (Tage)'
    },

    CheckInFields: {
      EnterLocationDetails: 'Standortdetails eingeben',
      Latitude: 'Breitengrad',
      Longitude: 'Längengrad',
      Radius: 'Radius',
      DegreesLatitude: 'Grad (-90.0 to 90.0)',
      DegreesLongitude: 'Grad (-180.0 to 180.0)',
      PermissibleRadiusInMeter: 'Zulässige Radius (In Meter)',
      PermissibleRadius: 'Zulässige Radius',
      Preview: 'VORSCHAU'
    },

    OutcomeSection: {
      Outcome: 'Ergebnis:',
      MediaTagsToInclude: 'Einzuschließende Media-Tags',
      SelectMediaTags: 'Media-Tags auswählen',
      SelectLoyaltyProgram: 'Treueprogramm auswählen',
      SelectPointEarnType: 'Punktesammeltyp auswählen',
      FixedPoints: 'Feste Punkte',
      VariablePoints: 'Variable Punkte',
      NumberOfPoints: 'Anzahl der Punkte',
      PointsSignHint:
        '(Positive Zahl eingeben, um Punkte hinzuzufügen, negative Zahl, um Punkte abzuziehen.)',
      Award: 'Vergeben',
      ForEvery: 'Für jeden',
      UpToAMaximumOf: 'Bis zu einem Maximum von',
      Currency: 'Währung',
      SelectGLAccount: 'GL-Konto auswählen',
      GLAccountName: 'GL-Kontoname',
      GLAccountNamePlaceholder: 'GL-Kontoname',
      Points: 'Punkte',
      GLAccountType: 'GL-Kontotyp',
      GLAccountTypePlaceholder: 'GL-Kontotyp',
      EnterKeyName: 'Schlüsselname eingeben',
      KeyName: 'Schlüsselname',
      EnterValueDetails: 'Wertdetails eingeben',
      KeyValue: 'Schlüsselwert',
      AddMore: 'Mehr hinzufügen'
    },

    OutcomeList: {
      RemoveOutcome: 'Ergebnis an Position {{position}} entfernen',
      MaxOutcomesReached: 'Eine Regel kann höchstens 10 Ergebnisse haben.',
      AddOutcome: 'Ergebnis hinzufügen',
      Position: 'Position {{position}}',
      Then: 'DANACH:',
      SequentialExecutionNotice: 'Ergebnisse werden sequenziell ausgeführt',
      OutcomeIdMatchesType:
        'Dieses Ergebnis passt nicht zum ausgewählten Ergebnistyp. Bitte erneut auswählen.'
    },

    OutcomeTypeField: {
      SelectOutcomeType: 'Ergebnistyp auswählen',
      Campaign: 'Kampagne',
      Rewards: 'Belohnungen',
      Points: 'Punkte',
      Audience: 'Zielgruppe',
      UpdateCustomerDetails: 'Kundendetails aktualisieren',
      PushEventOnly: 'Nur Push-Event',
      CustomFieldsTitle: 'Benutzerdefinierte Felder',
      AddCustomField: '+ Benutzerdefiniertes Feld hinzufügen',
      CustomFieldValidation: '{title} ist erforderlich.',

      CustomFields: {
        Key: 'Schlüssel',
        Value: 'Wert',
        CustomFieldsError: 'Bitte wählen Sie die richtigen benutzerdefinierten Felder aus!',
        UniqueKeyError: 'Schlüssel muss eindeutig sein!'
      }
    },

    OutcomeCampaignSelectField: {
      SelectCampaignType: 'Kampagnentyp auswählen',
      Stamp: 'Stempel',
      Game: 'Spiel',
      Quiz: 'Quiz',
      Survey: 'Umfrage',
      SelectCampaign: 'Kampagne auswählen',
      Change: 'Ändern',
      Select: 'Auswählen',
      Campaign: 'Kampagne',
      BonusStamps: 'Bonusstempel',
      BonusTries: 'Bonusversuche'
    },

    OutcomeRewardSelectField: {
      SelectReward: 'Belohnung auswählen',
      Change: 'Ändern',
      Reward: 'Belohnung',
      Select: 'Auswählen',
      OnlySystemRewardsShown: 'Es werden nur Systembelohnungen angezeigt.'
    },

    OutcomePointExpiry: {
      OutcomeExpiresAt: 'Ergebnis läuft ab am'
    },

    OutcomeAudienceField: {
      SelectAudienceList: 'Zielgruppenliste auswählen',
      SelectAudienceListPlaceholder: 'Zielgruppenliste auswählen'
    },

    LoyaltyAudience: {
      SelectAudience: 'Zielgruppe auswählen',
      DefaultAudience: 'Erstellen Sie eine einmalige Zielgruppe für diese Kampagne',
      ExistingAudience: 'Wählen Sie eine bestehende Zielgruppe aus',
      AudienceSetup: 'Zielgruppen-Setup',
      SelectAudienceV4Placeholder: 'Zielgruppe auswählen',
      SelectFilters: 'Filter auswählen',
      SelectedFilters: 'Ausgewählte Filter',
      NoFiltersSelected: 'Keine Filter ausgewählt',

      AudienceListSetup: {
        Include: 'Einschließen',
        Exclude: 'Ausschließen',
        AudienceExistsMessage: `Kann Zielgruppe nicht {{audienceIncludeExclude}}, die bereits für {{audienceIncludeExcludeNoun}} festgelegt ist`,
        PickAudienceList: 'Zielgruppenliste auswählen',

        Includes: 'Enthält',
        Excludes: 'Schließt aus',
        AudienceWarningMessage:
          'Die hochgeladene Zielgruppendatei wird erst nach Genehmigung durch einen Bulk-Actions-Prüfer verarbeitet',
        SelectedFileForInclusion: 'Ausgewählte Datei für Einschluss',
        AudienceNotInTheList: 'Zielgruppe nicht in der Liste',
        IncludeAudienceFilenamePlaceholder:
          'Benennen Sie die Liste der eingeschlossenen Zielgruppe',
        UploadNow: 'Jetzt hochladen',
        UploadNewList: 'Neue Liste hochladen',
        AcceptedFormat: 'Akzeptiertes Format: Nur .xlsx/.csv Dateien.',
        DownloadSample: 'Beispiel herunterladen',
        UploadExclusion: 'Ausschluss hochladen',
        SelectedFileForExclusion: 'Ausgewählte Datei für Ausschluss',
        ExcludeAudienceFilenamePlaceholder:
          'Benennen Sie die Liste der ausgeschlossenen Zielgruppe',

        SubmittingData: 'Daten werden übermittelt...',
        SomethingWentWrong: 'Etwas ist schief gelaufen.',
        AutoCreateCustomers: 'Kunden auch erstellen, wenn sie nicht existieren'
      },

      AudienceFilters: {
        Age: 'Alter',
        BirthMonth: 'Geburtsmonat',
        Gender: 'Geschlecht',
        Location: 'Standort',
        Loyalty: 'Treue',
        Personal: 'Persönlich',
        Custom: 'Benutzerdefiniert',
        EmailTags: 'E-Mail-Tags',
        Ethnicity: 'Ethnische Zugehörigkeit',
        SelectCustomerAttributeFilters: 'Wählen Sie Ihre Kundenattribut-Filter:',
        NoFiltersSelected: 'Keine Filter ausgewählt',
        And: 'und',
        Badge: 'Abzeichen',
        Campaign: 'Kampagne',
        Leaderboard: 'Bestenliste',
        LoyaltyPoints: 'Treuepunkte',
        LoyaltyTier: 'Treuestufe',
        MemberSince: 'Mitglied seit',
        Reward: 'Belohnung',
        PaymentBased: 'Zahlungsbasiert',
        Payment: 'Zahlung',
        SelectFilters: 'Filter auswählen, um automatisch eine Zielgruppenliste zu erstellen',
        City: 'Stadt',
        States: 'Bundesländer',
        age: 'alter',
        birthmonth: 'geburtsmonat',
        gender: 'geschlecht',
        race: 'ethnie',
        location: 'standort',
        loyalty_tier: 'treuestufe',
        personal: 'persönlich',
        email_tags: 'e_mail_tags',

        OfferId: 'Angebots-ID',
        PrimaryClusterComb: 'Primärer Cluster-Kamm',
        PrimaryClusterState: 'Primärer Cluster-Status',
        Membership: 'Mitglied von',
        CurrentBirthday: 'Nur am Geburtstag',
        CurrentBirthMonth: 'Nur im Geburtsmonat',
        HasBirthday: 'Am Geburtstag',
        UserType: 'Benutzertyp',
        AccountConfirmedAt: 'Angemeldet zwischen',
        LoyaltyPointsBalance: 'Punktestand',
        CampaignEnrolment: 'Kampagne',
        LeaderboardPosition: 'Position in der Bestenliste',
        UPI: 'UPI',
        ScanPay: 'Scan-Zahlung',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Aktuelle Adresse',
        PaymentStatus: 'Zahlungsstatus',
        DaysPastDues: 'Überfällige Tage',
        BNPLUnpaidEMIDate: 'BNPL unbezahltes EMI-Datum',
        InstaloanUnpaidEMIDate: 'Instaloan unbezahltes EMI-Datum',

        AgeFilter: {
          Title: 'Alter',
          Includes: 'Enthält',
          Excludes: 'Schließt aus',
          SelectPlaceholder: 'Enthält',
          From: 'Alter von',
          FromPlaceholder: '18',
          To: 'bis',
          ToPlaceholder: '35',
          AddRange: 'Bereich hinzufügen',
          And: 'und'
        },
        BirthdayFilter: {
          Title: 'Geburtstag',
          SelectBirthMonth: 'Geburtsmonat auswählen',
          BirthMonth: 'Geburtsmonat',
          CurrentBirthMonth: 'Aktueller Geburtsmonat',
          OnlyDuringMonthOfBirth: 'Nur während des Geburtsmonats',
          HasBirthday: 'Hat Geburtstag',
          OnBirthday: 'Am Geburtstag',
          Includes: 'Enthält',
          Excludes: 'Schließt aus'
        },
        GenderFilter: {
          Title: 'Geschlecht',
          SelectByGender: 'Nach Geschlecht auswählen',
          Male: 'Männlich',
          Female: 'Weiblich'
        },
        EthnicityFilter: {
          Title: 'Ethnische Zugehörigkeit',
          SelectEthnicity: 'Ethnische Zugehörigkeit auswählen',
          SelectEthnicityPlaceholder: 'Ethnische Zugehörigkeit auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          Includes: 'Enthält',
          Excludes: 'Schließt aus'
        },
        LocationFilter: {
          Title: 'Standort',
          SelectCity: 'Stadt auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          SelectCityPlaceholder: 'Städte auswählen',
          SelectState: 'Bundesland auswählen',
          SelectStatePlaceholder: 'Bundesland auswählen',
          Includes: 'Enthält',
          Excludes: 'Schließt aus'
        },

        PersonalFilter: {
          Title: 'Persönlich',
          HubClub: 'Hub Club',
          Select: 'Auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          AddCustomProperties: 'Benutzerdefinierte Eigenschaften hinzufügen',
          EnterKeyNameAndValueDetails: 'Geben Sie Schlüsselnamen und Wertdetails ein',
          SelectRelation: 'Beziehung auswählen',
          EnterNumber: 'Nummer eingeben',
          KeyValue: 'Schlüsselwert',
          DatePlaceholder: 'TT-MM-JJJJ',
          KeyNamePlaceholder: 'Schlüsselname',
          Is: 'Ist',
          True: 'Wahr',
          False: 'Falsch',
          And: 'UND',
          Or: 'ODER',
          CustomAttributeType: 'Benutzerdefiniertes Attribut #{{index}}: Typ',
          CustomAttribute: 'Benutzerdefiniertes Attribut #{{index}}: Attribut',
          CustomAttributeOperator: 'Benutzerdefiniertes Attribut #{{index}}: Operator',
          CustomAttributeValue: 'Benutzerdefiniertes Attribut #{{index}}: Wert',
          Includes: 'Enthält',
          Excludes: 'Schließt aus',
          CurrentTimestamp: 'Aktueller Zeitstempel',
          VsTimestampKeyInPersonalProperties: 'vs Timestamp-Schlüssel in personal_properties',
          EnterTimestampKeytoCheck: 'Geben Sie den zu überprüfenden Timestamp-Schlüssel ein',
          CurrentTimestampBy: 'Aktueller Zeitstempel nach',
          KeyMustBeIN: "Schlüssel muss im ISO8601-Format vorliegen -z.B.: '2025-01-01T00:00:00'"
        },

        LoyaltyFilter: {
          Title: 'Treue',
          SelectLoyaltyProgram: 'Treueprogramm auswählen',
          Include: 'Einschließen',
          Exclude: 'Ausschließen',
          SelectProgram: 'Programm auswählen',
          Includes: 'Enthält',
          Excludes: 'Schließt aus',
          UsersWhoAchieved: 'Benutzer, die erreichten',
          SelectProgramAndTier: 'Treueprogramm und Stufe auswählen',
          UsersWithPointsBalance: 'Benutzer mit Punktestand',
          SelectLoyaltyProgramPlaceholder: 'Treueprogramm auswählen',
          From: 'Von',
          To: 'Bis',
          PointsBalanceFrom: 'Punktestand von',
          PointsBalanceTo: 'Punktestand bis'
        },

        EmailTagsFilter: {
          Includes: 'Enthält',
          SelectEmailTags: 'E-Mail-Tags auswählen',
          Excludes: 'Schließt aus'
        },

        PaymentBasedFilter: {
          IncludeUsersWith: 'Benutzer mit',
          UPI: 'UPI',
          ScanPay: 'Scan-Zahlung',
          BBPS: 'BBPS',
          KYC: 'KYC',
          CurrentAddress: 'Aktuelle Adresse',
          PaymentStatus: 'Zahlungsstatus',
          DaysPastDues: 'Überfällige Tage',
          BNPLUnpaidEMIDate: 'BNPL unbezahltes EMI-Datum',
          InstaloanUnpaidEMIDate: 'Instaloan unbezahltes EMI-Datum',
          SelectFromList: 'Aus Liste auswählen',
          SelectDate: 'Datum auswählen',
          Upcoming: 'Kommend',
          DueNow: 'Jetzt fällig',
          Future: 'Zukünftig',
          Overdue: 'Überfällig',
          None: 'Keine'
        }
      }
    },

    RuleDetail: {
      Title: 'Regeldetails',
      RuleName: 'Regelname',
      Status: 'Status',
      StartTime: 'Startzeit',
      EndTime: 'Endzeit',
      Labels: 'Labels',
      Notification: 'Benachrichtigung',
      Owner: 'Besitzer',
      Partner: 'Partner',
      On: 'AN',
      Off: 'AUS',
      Merchant: 'Händler',
      Trigger: 'Auslöser',
      TriggerType: 'Auslösertyp',
      TriggerEventName: 'Auslöserereignisname',
      Conditions: 'Bedingungen',
      Campaign: 'Kampagne',
      Reward: 'Belohnung',
      Loyalty: 'Treue',
      Tier: 'Stufe',
      AutomationTrigger: 'Automatisierungsauslöser',
      TotalTriggerLimit: 'Gesamtauslöserlimit',
      UserLifetimeLimit: 'Benutzer-Lebenszeitlimit',
      TriggerLimitPerUser: 'Auslöserlimit (pro Benutzer)',
      TriggerLimitOnCampaignLevel: 'Auslöserlimit (auf Kampagnenebene)',
      Outcome: 'Ergebnis',
      OutcomeType: 'Ergebnistyp',
      OutcomeProperties: 'Ergebnis-Eigenschaften',
      OutcomePropertyKey: 'Schlüssel',
      OutcomePropertyValue: 'Wert',
      GLAccountNumber: 'GL-Kontonummer',
      GLAccountName: 'GL-Kontoname',
      GLAccountType: 'GL-Kontotyp',
      CostCenterId: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',
      AudienceInfo: 'Zielgruppeninfo',
      TimesPerUser: 'Male pro',
      ID: 'ID',
      Field: 'Feld',
      FilteringChecks: {
        Title: 'Filterprüfungen',
        Description: 'Prüfen Sie, welche Filter für diese Regel bestehen oder fehlschlagen.',
        HelperText:
          'Führen Sie eine Prüfung aus, um zu sehen, welche Filter bestehen oder fehlschlagen.',
        PassedFilters: 'Bestandene Filter',
        FailedFilters: 'Fehlgeschlagene Filter',
        NoPassedFilters: 'Keine bestandenen Filter',
        NoFailedFilters: 'Keine fehlgeschlagenen Filter',
        GenericError: 'Kunden-ID ist ungültig.',
        NotFoundError: '404 nicht gefunden',
        Button: 'Filter prüfen',
        Transaction: {
          Label: 'Transaktionsregel-Filterprüfungen',
          Placeholder: 'Transaktions-ID eingeben',
          InputLabel: 'Transaktions-ID',
          MissingIdError: 'Bitte eine Transaktions-ID eingeben',
          InvalidIdError: 'Die Transaktions-ID ist ungültig'
        },
        EventLog: {
          Label: 'Event-Log-Regel-Filterprüfungen',
          Placeholder: 'Event-Log-ID eingeben',
          InputLabel: 'Ereignisprotokoll-ID',
          MissingIdError: 'Bitte eine Event-Log-ID eingeben',
          InvalidIdError: 'Die Event-Log-ID ist ungültig'
        }
      }
    },

    CampaignDetail: {
      CampaignID: 'Kampagnen-ID',
      CampaignName: 'Kampagnenname',
      CampaignType: 'Kampagnentyp',
      BonusStamps: 'Bonusstempel',
      BonusTries: 'Bonusversuche'
    },

    RewardDetail: {
      RewardID: 'Belohnungs-ID',
      RewardName: 'Belohnungsname'
    },

    LoyaltyDetail: {
      CampaignName: 'Kampagnenname',
      Points: 'Punkte',
      OutcomeExpiresAt: 'Ergebnis läuft ab am',
      ForEvery: 'Für jede',
      UpToAMaximumOf: 'Bis zu einem Maximum von'
    },

    LoyaltyTier: {
      NextTiers: 'Nächste Stufen',
      NextTier: 'Nächste Stufe'
    },

    AutomationTrigger: {
      AutomationTrigger: 'Automatisierungsauslöser'
    },

    RuleRequestComment: {
      Content: 'Inhalt',
      DeleteButton: 'Löschen-Schaltfläche',
      UserDescription: 'Benutzerbeschreibung',
      UserRole: 'Benutzerrolle',
      Description: 'Beschreibung',
      Delete: 'Löschen',
      Time: 'Zeit',
      PendingRule: 'Ausstehende Regel',
      Approve: 'Genehmigen',
      AddComment: 'Kommentar hinzufügen',
      ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
      ApproveRule: 'Regel genehmigen',
      PendingRuleDescription:
        'Diese Regel wartet auf die Genehmigung der Prüfer. Alle hinzugefügten Kommentare werden hier angezeigt.',
      CommentsAdded: 'Kommentare hinzugefügt'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Kommentar gelöscht',
      ErrorMessage: 'Fehler beim Löschen des Kommentars',
      Title: 'Kommentar löschen?',
      OkText: 'Löschen',
      DescriptionLineOne: 'Sind Sie sicher, dass Sie Ihren Kommentar löschen möchten?',
      DescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      CancelText: 'Abbrechen'
    },

    ApproveDenyCampaignRequestModalTitle: 'Kampagne genehmigen?',
    ApproveDenyCampaignRequestModalButton: 'Genehmigen',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'Anfrage wurde genehmigt',
      ErrorMessage: 'Etwas ist schief gelaufen',

      ApproveTitle: 'Kampagne genehmigen?',
      Title: 'Löschantrag einreichen?',
      ApproveOkText: 'Genehmigen',
      OkText: 'Löschung beantragen',
      CancelText: 'Abbrechen',

      ApproveDescriptionLineOne: 'Sind Sie sicher, dass Sie diese Kampagne genehmigen möchten?',
      ApproveDescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',

      DescriptionLineOne:
        'Diese Regel wartet auf Genehmigung. Sind Sie sicher, dass Sie sie löschen möchten?',
      DescriptionLineTwo:
        'Sobald die Löschung genehmigt ist, wird diese Regel nicht mehr verfügbar sein und Sie müssen sie erneut erstellen.',
      ApproveRuleTitle: 'Regel genehmigen?',
      SubmitDeletionRequestTitle: 'Löschantrag einreichen?',
      RequestDeletionOkText: 'Löschung beantragen',
      ApproveRuleDescriptionLineOne: 'Sind Sie sicher, dass Sie diese Regel genehmigen möchten?',
      ApproveRuleDescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.'
    },

    AddCommentModalTitle: 'Kommentare anzeigen und hinzufügen',
    AddCommentModalButton: 'Kommentar hinzufügen',
    AddCommentModal: {
      SuccessMessage: 'Kommentar hinzugefügt',
      ErrorMessage: 'Fehler beim Hinzufügen des Kommentars',
      CancelText: 'Abbrechen',
      CommentInputPlaceholder: 'Geben Sie hier Ihren Kommentar ein',
      AddCommentButton: 'Kommentar hinzufügen'
    },

    AudienceInfoTitle: 'Zielgruppen-Info',

    AudienceInfo: {
      Description: 'Ausgewählte Zielgruppe:',
      NoListsSelected: 'Keine Listen ausgewählt',
      Include: 'Einschließen',
      Exclude: 'Ausschließen',
      AudienceAttributes: 'Zielgruppenattribute',
      AudienceList: 'Zielgruppenliste',
      NoFiltersSelected: 'Keine Filter ausgewählt',
      MakerCheckerSuccess: 'Anfrage zur Genehmigung eingereicht',
      Success: 'Automatisierungsregel erfolgreich bearbeitet!',
      TransactionRulesError: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.',
      RuleRequestError: 'Fehler beim Einrichten der Automatisierung',
      TransactionRulesSuccess: 'Automatisierungsregel erstellt!',
      TransactionRulesMakerCheckerSuccess: 'Regel zur Genehmigung eingereicht',
      TransactionRulesRequestError: 'Fehler beim Einrichten der Automatisierung'
    },

    AudienceInfoFilters: {
      Loyalty: 'Treue',
      Gender: 'Geschlecht',
      Age: 'Alter',
      BirthMonth: 'Geburtsmonat',
      Ethnicity: 'Ethnizität',
      City: 'Stadt',
      States: 'Bundesländer',
      OfferId: 'Angebots-ID',
      PrimaryClusterComb: 'Primäre Cluster-Kombination',
      PrimaryClusterState: 'Primärer Cluster-Status',
      MemberOf: 'Mitglied von',
      OnlyDuringDayOfBirth: 'Nur am Geburtstag',
      OnlyDuringMonthOfBirth: 'Nur im Geburtsmonat',
      OnBirthday: 'Am Geburtstag',
      UserType: 'Benutzertyp',
      EmailTags: 'E-Mail-Tags',
      SignedUpBetween: 'Angemeldet zwischen',
      Reward: 'Belohnung',
      Badge: 'Abzeichen',
      PointsBalance: 'Punktestand',
      Campaign: 'Kampagne',
      LeaderboardPosition: 'Position in der Bestenliste',
      Upi: 'UPI',
      ScanPay: 'Scan-Bezahlung',
      Bbps: 'BBPS',
      Kyc: 'KYC',
      CurrentAddress: 'Aktuelle Adresse',
      PaymentStatus: 'Zahlungsstatus',
      DaysPastDues: 'Überfällige Tage',
      BnplUnpaidEmiDate: 'BNPL unbezahltes EMI-Datum',
      InstaloanUnpaidEmiDate: 'Instaloan unbezahltes EMI-Datum',
      Include: 'Einschließen',
      Exclude: 'Ausschließen'
    },

    ApproveDenyTransactionRuleRequestModal: {
      ApproveRuleTitle: 'Regel Genehmigen?',
      SubmitDeletionRequestTitle: 'Löschanfrage Senden?',
      RequestDeletionOkText: 'Löschung Anfordern',
      ApproveRuleDescriptionLineOne: 'Sind Sie Sicher, Dass Sie Diese Regel Genehmigen Möchten?',
      ApproveRuleDescriptionLineTwo: 'Diese Aktion Kann Nicht Rückgängig Gemacht Werden.',
      ApproveOkText: 'Genehmigen',
      CancelText: 'Abbrechen',
      DescriptionLineOne:
        'Diese Regel Wartet Auf Genehmigung. Sind Sie Sicher, Dass Sie Sie Löschen Möchten?',
      DescriptionLineTwo:
        'Sobald Die Löschung Genehmigt Ist, Wird Diese Regel Nicht Mehr Verfügbar Sein Und Muss Neu Erstellt Werden.'
    },

    OutcomeType: {
      IssueRewardFromCampaign: 'Belohnung aus Kampagne ausgeben',
      IssueRewardfromCampaign: 'Belohnung aus Kampagne ausgeben',
      IssueRewardFromMerchant: 'Belohnung vom Händler ausgeben',
      IssueReward: 'Belohnung ausgeben',
      IssueVoucher: 'Gutschein ausstellen',
      AnyVoucherExpiring: 'Beliebiger Gutschein läuft in {{unit}} {{period}} ab',
      ParticularRewardExpiring:
        'Gutschein für eine bestimmte Belohnung läuft in {{unit}} {{period}} ab',

      AchievedNextTier: 'Nächstes Level erreicht',
      NearTier: '10 % bis zum nächsten Level',
      PointsIssued: 'Punkte ausgegeben',
      AgeingPoints: 'Verfallende Punkte',

      RedeemReward: 'Belohnung einlösen',
      VoucherIssuedReward: 'Belohnung ausgeben',
      VoucherIssuedCampaign: 'Belohnung aus Kampagne ausgeben',
      VoucherIssuedMerchant: 'Belohnung vom Händler ausgeben',
      VoucherExpiry: 'Beliebiger Gutschein läuft ab',
      VoucherExpiryParticularReward: 'Gutschein für bestimmte Belohnung läuft ab',

      StampRedeemed: 'Stempel eingelöst',
      StampsIssued: 'Stempel ausgegeben',
      StampsInactive: 'Stempel inaktiv',
      CampaignCompleted: 'Kampagne abgeschlossen',
      CampaignNotCompleted: 'Kampagne nicht abgeschlossen',
      GamePlayed: 'Spiel gespielt',
      GameTryIssued: 'Spielversuch ausgegeben',
      CampaignEnrolled: 'Kampagne eingeschrieben',
      ProgressLevelAchieved: 'Fortschrittsstufe erreicht',
      ProgressRuleTriggered: 'Fortschrittsregel ausgelöst',
      QuestTaskCompleted: 'Quest-Aufgabe abgeschlossen',
      CampaignOutcomeIssued: 'Kampagnenergebnis ausgegeben',

      SignUp: 'Registrierung',
      SignIn: 'Anmeldung',
      ProfileUpdated: 'Profil aktualisiert',

      TransactionCreated: 'Transaktion erstellt',

      CheckIn: 'Check-in'
    }
  }
};
